export * from './decorators/all.js';
export * from './extractTestsFromModule.js';
export * from './options/testParserFlags.js';
export * from './options/testParserOptions.js';
export * from './parser/models/test.js';
export * from './parser/models/testCollection.js';
export * from './parser/models/testType.js';

import { keywords } from './parser/keywords.js';

/**
 * Keyword for marking a test or group as 'only' for execution filtering.
 */
export const only = keywords.only;

/**
 * Helper object providing access to test metadata keywords.
 */
export const test = {
  /** Keyword for 'only' filtering. */
  only: keywords.only,
  /** Keyword for custom test titles. */
  title: keywords.title,
  /** Keyword for parameterized test cases. */
  cases: keywords.cases
}
